import React, { useState, useRef, useEffect } from 'react';
import { FaSearch, FaBars } from 'react-icons/fa';
import { Link,  useLocation, useNavigate } from 'react-router-dom';
import profilePic from '../assets/admin-avatar.png';
import mail from '../assets/mail.png';
import notification from '../assets/notifications.png';
import searchIcon from '../assets/search.png';
import help from '../assets/help.png';
import home from '../assets/home-2.png';
import transaction from '../assets/note-01.png';
import product from '../assets/store.png';
import customers from '../assets/user-group.png';
import sales from '../assets/line-chart.png';
import settings from '../assets/settings.png';
import dark from '../assets/moon.png';
import arrow from '../assets/arrow-down-simple.png';
import agarliLogo from '../assets/agarli-logo.png';
import { useAuth } from '../contexts/AuthContext';
import { CATEGORY_LIST, CATEGORY_LABELS } from '../constants/agencyCategories';
import DarkModeSwitch from './DarkModeSwitch';
import { Bell } from "lucide-react";
import NotificationsPanel from "./NotificationsPanel";

const Navbar = ({ isSidebarOpen, toggleSidebar }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const sidebarRef = useRef();
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeSidebar = () => setIsMobileMenuOpen(false);

  const [open, setOpen] = useState(false);

  const { user } = useAuth();

  const notifications = [
    { id: 1, text: "Order #1234 has been shipped", time: "2m ago" },
    { id: 2, text: "New message from support team", time: "10m ago" },
    { id: 3, text: "Password changed successfully", time: "1h ago" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        closeSidebar();
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileMenuOpen]);

  const [isProductsOpen, setIsProductsOpen] = useState(false);
    const [isUsersOpen, setIsUsersOpen] = useState(false);
    const toggleProducts = () => setIsProductsOpen(!isProductsOpen);
    const toggleUsers = () => setIsUsersOpen(!isUsersOpen);
  
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div
      className={`fixed top-0 right-0 h-16 bg-white shadow-agarly-sm dark:bg-agarly-700 border-b border-agarly-surface/60 flex items-center justify-between px-4 sm:px-10 transition-all duration-300 z-40 left-0 w-full
        ${isSidebarOpen ? 'sm:left-72 sm:w-[calc(100%-18rem)]' : 'sm:left-20 sm:w-[calc(100%-5rem)]'}`}
    >
      {/* Left Section */}
      <div className="flex items-center gap-4 flex-shrink-0">
        {/* Mobile Menu Button */}
        <button onClick={toggleMobileMenu} className="md:hidden text-2xl dark:text-gray-200 focus:outline-none">
          <FaBars />
        </button>

        {/* Mobile Search Icon */}
        <button className="sm:hidden p-2 dark:text-gray-200 rounded hover:bg-gray-100">
          <FaSearch className="w-5 h-5" />
        </button>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div ref={sidebarRef} className="animate:slideFromLeft dark:bg-[#1A1A1B] overflow-y-auto flex flex-col absolute top-16 left-0 w-[70%] h-screen bg-white shadow-md p-4 md:hidden scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent text-sm font-light flex-1">
            <div className="flex ">
              <img src={agarliLogo} alt="Logo" className="w-20 h-14 object-contain transition-all duration-300" />
            </div>

            <ul className="space-y-2 text-gray-700 dark:text-gray-300 text-base">
              <p className="text-gray-400 dark:text-gray-200 text-xs uppercase mb-2 tracking-wide">General</p>

              {/* Dashboard */}
              <li
                className={`rounded-2xl transition-all ${
                  location.pathname === "/dashboard"
                    ? "bg-blue-100 text-gray-700 font-bold"
                    : "text-gray-600 dark:text-gray-300 hover:bg-gray-100"
                }`}
                onClick={closeSidebar}
              >
                <Link to="/dashboard" className="flex items-center gap-3 p-3 rounded-xl">
                  <img src={home} alt="dashboard" className="w-6 h-6" />
                  <span className="inline md:hidden md:inline">{'Dashboard'}</span>
                </Link>
              </li>

              {/* Products */}
              <li className="rounded-xl transition text-gray-600 dark:text-gray-300">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    toggleProducts();
                  }}
                  className={`flex items-center justify-between w-full rounded-2xl cursor-pointer transition-colors ${
                    location.pathname.startsWith("/products")
                      ? "bg-blue-100 text-gray-700 font-bold"
                      : "hover:bg-gray-100"
                  }`}
                >
                  <div className="flex items-center gap-3 p-3 w-full rounded-xl">
                    <img src={product} alt="products" className="w-6 h-6" />
                    {isSidebarOpen && <span>Categories</span>}
                  </div>

                  {isSidebarOpen && (
                    <div className="p-3 rounded-xl">
                      <img
                        src={arrow}
                        alt="toggle"
                        className={`w-5 h-5 transition-transform ${
                          isProductsOpen ? "rotate-180" : ""
                        }`}
                      />
                    </div>
                  )}
                </div>

                {/* Products dropdown */}
                {isProductsOpen && isSidebarOpen && (
                  <ul className="mt-2 space-y-2">
                    {CATEGORY_LIST.map((key) => (
                      <li key={key} onClick={closeSidebar}>
                        <button
                          className={`block w-full text-left px-2 py-1 pl-8 rounded-agarly-md transition-colors ${
                            location.search.includes(`selected=${key}`)
                              ? "bg-agarly-light text-agarly-dark font-bold"
                              : "hover:bg-agarly-light/50 hover:text-agarly-dark"
                          }`}
                          onClick={() => navigate(`/products?selected=${key}`)}
                        >
                          {CATEGORY_LABELS[key]}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </li>


            <li className="rounded-xl transition text-gray-600 dark:text-gray-300">
              <div
                onClick={(e) => {
                  e.preventDefault();
                  toggleUsers();
                }}
                className={`flex items-center justify-between w-full rounded-2xl cursor-pointer transition-colors ${
                  location.pathname.startsWith("/Users")
                    ? "bg-blue-100 text-gray-700 font-bold"
                    : "hover:bg-gray-100"
                }`}
              >
                <div className="flex items-center gap-3 p-3 w-full rounded-xl">
                  <img src={customers} alt="products" className="w-6 h-6" />
                  {isSidebarOpen && <span>Users</span>}
                </div>

                {isSidebarOpen && (
                  <div className="p-3 rounded-xl">
                    <img
                      src={arrow}
                      alt="toggle"
                      className={`w-5 h-5 transition-transform ${
                        isUsersOpen ? "rotate-180" : ""
                      }`}
                    />
                  </div>
                )}
              </div>

              {/* Users dropdown */}
              {isUsersOpen && isSidebarOpen && (
                <ul className="mt-2 space-y-2">
                  {[
                    { name: "Vendors", key: "vendors" },
                    { name: "Customers", key: "customers" },
                  ].map((item) => (
                    <li key={item.key} onClick={closeSidebar}>
                      <button
                        className={`block w-full text-left px-2 py-1 pl-8 rounded-lg transition-colors
                          ${
                            location.search.includes(`selected=${item.key}`)
                              ? "bg-gray-100 text-gray-700  font-bold"
                              : "hover:bg-gray-50 hover:text-gray-700"
                          }
                        `}
                        onClick={() => navigate(`/Users?selected=${item.key}`)}
                      >
                        {item.name}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            {/* Other menu items */}
            {[
              { path: "/transactions", icon: transaction, label: "Orders" },
              { path: "/sales", icon: sales, label: "Sales Report" },
              ].map((item, i) => (
                <li
                  key={i}
                  className={`rounded-2xl transition-all ${
                    location.pathname.startsWith(item.path)
                      ? "bg-blue-100 text-gray-700 font-bold"
                      : "text-gray-600 dark:text-gray-300 hover:bg-gray-100"
                  }`}
                  onClick={closeSidebar}
                >
                  <Link to={item.path} className="flex items-center gap-3 p-3 rounded-xl">
                    <img src={item.icon} alt={item.label} className="w-6 h-6" />
                    <span className="inline md:hidden md:inline">{item.label}</span>
                  </Link>
                </li>
              ))}

              <p className="text-gray-400 dark:text-gray-200 text-xs uppercase mb-2 tracking-wide">Tools</p>

              {[
                { path: "/settings", icon: settings, label: "Account & Settings" },
                { path: "/chat", icon: mail, label: "Chat" },
              ].map((item, i) => (
                <li
                  key={i}
                  className={`rounded-2xl transition-all ${
                    location.pathname === item.path
                      ? "bg-blue-100 text-gray-700 font-bold"
                      : "text-gray-600 dark:text-gray-300 hover:bg-gray-100"
                  }`}
                  onClick={closeSidebar}
                >
                  <Link to={item.path} className="flex items-center gap-3 p-3 rounded-xl">
                    <img src={item.icon} alt={item.label} className="w-6 h-6" />
                    <span className="inline md:hidden md:inline">{item.label}</span>
                  </Link>
                </li>
              ))}

              {/* Dark mode */}
              <li>
                <div className="flex justify-between items-center gap-3 hover:bg-gray-100 p-3 rounded-xl">
                  <div className="flex items-center gap-3">
                    <img src={dark} alt="darkmode" className="w-6 h-6" />
                    <span className="inline dark:text-gray-300 md:hidden md:inline">Dark Mode</span>
                  </div>
                  <DarkModeSwitch />
                </div>
              </li>
            </ul>
          </div>
        )}

        {/* Desktop Search Box */}
        <div className="hidden sm:block relative">
          <input
            type="text"
            placeholder="Search"
            className="focus:outline-none focus:ring-2 focus:ring-agarly-primary/40 border border-agarly-surface rounded-agarly-lg pr-10 pl-3 py-2 text-l w-[300px] dark:text-gray-300 dark:bg-agarly-800"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2">
            <img src={searchIcon} alt="search" className="w-5 h-5" />
          </span>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-5">
        
        <div className="relative flex items-center justify-center">
      {/* زرار مؤقت للتجربة */}
      <button
        onClick={() => setOpen(true)}
        className=" bg-gray-100 rounded-lg p-1 cursor-pointer hover:bg-gray-200 transition w-8 h-8 dark:bg-[#2D2D2D] "
      >
          <img src={notification} alt="notification" className="" />
      </button>

      {/* البانيل */}
      <NotificationsPanel
        open={open}
        notifications={notifications}
        onClose={() => setOpen(false)}
      />
    </div>

        {/* Divider */}
        <div className="hidden sm:block w-[2px] h-10 bg-gray-300 rounded-sm dark:bg-gray-400"></div>

        {/* Profile */}
        <Link to="/settings" className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-[#2D2D2D] transition">
          <img src={profilePic} alt="User" className="w-8 h-8 rounded-lg" />
          <div className="hidden sm:flex flex-col">
            <p className="text-sm font-medium dark:text-gray-300">{user?.name}</p>
            <p className="text-xs text-agarly-gray dark:text-gray-400">{user?.role}</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Navbar;
